<!--
 * @Description: 二次封装高德地址poi搜索选择器
 * @Author: lijinpeng
 * @Date: 2022-05-16 10:23:57
 * @LastEditTime: 2024-06-21 16:45:01
 * @LastEditors: lijinpeng
-->
<template>
  <el-autocomplete
    ref="address"
    v-model="address"
    :fetch-suggestions="fetchCitySearch"
    :placeholder="placeholder"
    :trigger-on-focus="false"
    :disabled="disabled"
    :size="size"
    @blur="handleBlur"
    @select="handleSelect"
  >
    <template slot-scope="{ item }">
      <template v-if="item.num">
        <div class="name whileSpace">
          {{ item.name }}
          <span style="float: right" class="addr ellipsis _999999 font_10">
            有{{ item.num }}个同名地点
          </span>
        </div>
      </template>
      <el-tooltip v-else class="item" effect="dark" :content="item.content" placement="right">
        <div>
          <div class="name">
            {{ item.name }}
          </div>
          <div class="addr ellipsis _999999 font_10">
            {{ item.content }}
          </div>
        </div>
      </el-tooltip>
    </template>
  </el-autocomplete>
</template>
<script>
import { getInputPoiPlace } from '@/api/common';

export default {
  name: 'NfAddressSelect',
  props: {
    // 绑定值
    value: {
      type: String,
      default: '',
    },
    // 输入框占位文本
    placeholder: {
      type: String,
      default: '请输入地址',
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    // 输入框尺寸
    size: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      address: '',
      type: 'pois',
    };
  },
  watch: {
    value: {
      handler(newValue) {
        this.address = newValue;
      },
      immediate: true,
    },
  },
  methods: {
    // 发货地/卸货地 详细地址
    async fetchCitySearch(queryString, callback) {
      if (queryString.length < 3) {
        callback([]);
        return;
      }
      const { data } = await getInputPoiPlace({
        keywords: queryString.replace(/\s*/g, ''),
      });
      let tips = [];
      if (data.suggestion && data.suggestion.cities && data.suggestion.cities.length > 0) {
        this.type = 'cities';
        tips = data.suggestion.cities.map(item => {
          item = JSON.parse(item);
          return {
            name: item.name,
            value: item.name,
            num: item.num,
            address: queryString,
          };
        });
        callback(tips);
        return;
      }
      if (data && data.pois && data.pois.length > 0) {
        this.type = 'pois';
        data.pois.map(item => {
          const content =
            item.pname === item.cityname ? item.pname : `${item.pname}${item.cityname}`;
          item.content = `${content}${item.adname} ${
            ![item.pname, item.cityname, item.adname, '[]'].includes(item.address)
              ? item.address
              : ''
          }`;
          return item;
        });
        callback(data.pois);
        return;
      }
      callback([]);
    },
    // 失去焦点
    handleBlur() {
      this.address = this.value;
      this.$emit('blur', this.address);
    },
    // 发货地/卸货地 下拉选
    handleSelect(item) {
      const { value, name, pname, cityname, adname, adcode, id } = item;
      let { location, address } = item;
      address = address !== '[]' ? address : '';
      if (this.type === 'cities') {
        this.address = address;
        this.$refs['address'].getData(value + address);
        return;
      }
      if (this.type === 'pois') {
        address = ![pname, adname, cityname].includes(address) ? address : '';
        const addr = {
          id,
          adcode,
          address,
          province: pname,
          city: cityname,
          district: adname,
        };
        if (typeof location === 'string') {
          location = location.split(',');
        }
        if (location) {
          addr.longitude = location[0]; // 经度
          addr.latitude = location[1]; // 纬度
        }
        addr.addressView =
          pname === cityname
            ? `${name}${cityname}${adname}${address}`
            : `${name}${pname}${cityname}${adname}${address}`;
        // addr.addressView = address ? `${name}-${address}` : name;
        this.address = addr.addressView;
        this.$emit('input', addr.addressView);
        this.$emit('select', addr);
      }
    },
  },
};
</script>
<style>
.el-autocomplete-suggestio {
  min-width: 210px !important;
}
</style>
